import { Box, styled } from '@material-ui/core';
import { TextColor } from '@setvi/shared/enums';

export const LastUpdated = styled(Box)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  padding: theme.spacing(1, 2),
  backgroundColor: '#F8F9FA',
  color: TextColor.SlateGrey,
  width: 'fit-content',
  borderRadius: 16
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: theme.spacing(0, 0, 3, 2)
}));
